if (!customElements.get("popup-overlay")) {
  customElements.define(
    "popup-overlay",
    class PopupOverlay extends ModalDialog {
      constructor() {
        super();
        this.delay = parseInt(this.dataset.delay, 10) * 1000;
        this.id = this.getAttribute("id");
        this.moved = true;
      }
      connectedCallback() {
        if (localStorage.getItem(this.id) !== "dismissed" && !Shopify.designMode) {
          setTimeout(() => {
            // QW7: Vis kun popup hvis cookie-consent allerede er givet
            // Forhindrer at popup og cookie-banner vises samtidig
            var cookieConsent = document.cookie.match(/nc_cookie_consent=/);
            var cookieBanner = document.getElementById('nc-cookie-banner');
            var cookieBannerVisible = cookieBanner && cookieBanner.style.display !== 'none';
            if (cookieConsent && !cookieBannerVisible) {
              this.show();
            } else if (!cookieConsent) {
              // Vent til cookie-consent er givet, tjek hvert 2. sekund
              var checkInterval = setInterval(() => {
                var consent = document.cookie.match(/nc_cookie_consent=/);
                var banner = document.getElementById('nc-cookie-banner');
                var bannerHidden = !banner || banner.style.display === 'none';
                if (consent && bannerHidden) {
                  clearInterval(checkInterval);
                  // Vent yderligere 2 sekunder efter cookie-accept
                  setTimeout(() => this.show(), 2000);
                }
              }, 2000);
              // Stop efter max 5 minutter
              setTimeout(() => clearInterval(checkInterval), 300000);
            }
          }, this.delay);
        }
        return super.connectedCallback();
      }
      show() {
        super.show();
        document.body.classList.remove("overflow-hidden");
        const event = new CustomEvent("popup-overlay:open", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);
      }
      hide() {
        super.hide();
        const event = new CustomEvent("popup-overlay:close", {
          detail: {
            id: this.id,
          },
        });
        document.dispatchEvent(event);
        if (!Shopify.designMode) {
          localStorage.setItem(this.id, "dismissed");
        }
      }
    },
  );
}
